import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class SmartFieldComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentSmartField | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.conditional = settings?.conditional ?? {
			eq:   '',
			show: undefined,
			when: undefined,
		};
		this.defaultValue = settings?.defaultValue ?? null;
		this.disabled = settings?.disabled ?? false;
		this.displayInputPopup = settings?.displayInputPopup ?? false;
		this.displaySuggestBtn = settings?.displaySuggestBtn ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.inputMask = settings?.inputMask ?? '';
		this.kdata = {
			mf_order:  undefined,
			sm_qrcode: false,
			submit:    true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.prefix = settings?.prefix ?? '';
		this.protected = settings?.protected ?? false;
		this.spellcheck = settings?.spellcheck ?? true;
		this.suffix = settings?.suffix ?? '';
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
			maxLength:     settings?.validate?.maxLength ?? null,
			minLength:     settings?.validate?.minLength ?? null,
			pattern:       settings?.validate?.pattern ?? '',
			unique:        settings?.validate?.unique ?? false,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'kid',
			'name',
		]);
	}
}